module.exports = __webpack_public_path__ + "img/personality-type-analysis.2371a990.svg";